import { Alert } from '@ps/sports-ui-component-library';
import React, { useEffect } from 'react';
import { useFormState } from 'react-final-form';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';
import TranslationWithLink from '@swf/sports/components/TranslationWithLink/TranslationWithLink';
import { BET_SLIP_AUTO_DISMISS_DELAY } from '@swf/sports/utils/constants';

import useDismissibleBetSlipError from '../../../../hooks/useDismissibleBetSlipError';

import { TXTWCL_Close } from './Error.messages.json';

const Error: React.FC = () => {
  const {
    titleTranslationTag,
    contentTranslationTag,
    isAutoDismissible,
    dismissError,
    link,
    level,
    variant,
    isCollapsible
  } = useDismissibleBetSlipError();
  const { submitErrors, values } = useFormState();
  const { formatMessage } = useRegulatoryIntl();
  useEffect(() => {
    if (!contentTranslationTag || !submitErrors) {
      return;
    }

    const hasExistingError = Object.keys(values).some((valueKey) => submitErrors[valueKey]);
    if (!hasExistingError) {
      dismissError();
    }
  }, [dismissError, contentTranslationTag, submitErrors, values]);

  useEffect(() => {
    if (contentTranslationTag && isAutoDismissible) {
      const timeout = setTimeout(dismissError, BET_SLIP_AUTO_DISMISS_DELAY);

      return () => {
        clearTimeout(timeout);
      };
    }
  }, [contentTranslationTag, isAutoDismissible, dismissError]);

  if (!contentTranslationTag) {
    return null;
  }

  if (titleTranslationTag) {
    return (
      <Alert
        title={formatMessage(titleTranslationTag)}
        level={level ?? 'destructive'}
        variant={variant ?? 'aggressive'}
        isSquare
        isCollapsible={isCollapsible ?? true}
      >
        <TranslationWithLink contentTranslationTag={contentTranslationTag} link={link} />
      </Alert>
    );
  }

  return (
    <Alert
      level="destructive"
      variant="aggressive"
      isAutoDismissible={isAutoDismissible}
      onDismiss={dismissError}
      dismissLabel={formatMessage(TXTWCL_Close)}
      isSquare
    >
      <TranslationWithLink contentTranslationTag={contentTranslationTag} link={link} />
    </Alert>
  );
};

export default Error;
